import React, { ButtonHTMLAttributes, Fragment } from "react";

type ButtonSecondaryProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  text?: string;
  size?: string;
  className?: string;
};

export const ButtonSecondary: React.FC<ButtonSecondaryProps> = ({
  size = "smallxs",
  text,
  className,
  ...props
}) => (
  <button
    {...props}
    type="button"
    className={`w-full rounded-md bg-white ${
      size === "small"
        ? "px-2 py-1 text-sm"
        : size === "medium"
          ? "px-2.5 py-1.5 text-sm"
          : size === "large"
            ? "px-3 py-2 text-sm"
            : size === "extraLarge"
              ? "px-3.5 py-2.5 text-sm"
              : "px-2 py-1 text-xs"
    } font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 ${className}`}
  >
    {text}
  </button>
);
